export default __webpack_public_path__ + "static/media/dataAnalysisPreview.b7dbb8ad.jpeg";